import api from "../api";
import { Report } from "../../models";
import { AccessToken, IAccessToken } from "../../models/AccessToken";
import { FailedToGetReportError, FailedToGetReportAccessTokenError, ReportNotFoundError } from "../../errors";
import { ApiException } from "../generated";
import { FailedToRefreshPermissionsError } from "../../errors/FailedToRefreshPermissionsError";

export const reportsService = {
    getReportsAuth: async () => {
        try {
            const response = await api.auth();
            const model: IAccessToken = new AccessToken(response.accessToken ?? "", response.expiration ?? new Date());
            return model;
        } catch {
            throw new FailedToGetReportAccessTokenError();
        }
    },

    getReport: async (relativeUrl: string) => {
        try {
            const response = await api.reports(relativeUrl);
            const model: Report = {
                id: response.id ?? "",
                name: response.name ?? "",
                embedUrl: response.embedUrl ?? ""
            };
            return model;
        } catch (error) {
            if ((error as ApiException)?.status === 404) {
                throw new ReportNotFoundError();
            } else {
                throw new FailedToGetReportError();
            }
        }
    },

    refreshPermissions: async () => {
        try {
            const response = await api.refreshPermissions()
            return response;
        } catch {
            throw new FailedToRefreshPermissionsError();
        }
    }
};
